export interface IndexIndicatorItem {
    id: number;
    name: string;
    description: string;
    unit: string;
}

export interface IndexCollectionItem {
    id: number;
    name: string;
    indicators: IndexIndicatorItem[];
}

export interface IndexAttributeItem {
    id: number;
    name: string;
    description: string;
    collections: {
        id: number;
        name: string;
        weight: number;
    }[];
}

export interface IndexValues {
    indicators: IndexIndicatorItem[];
    collections: IndexCollectionItem[];
    attributes: IndexAttributeItem[];
}

import { getEnvParam } from "@/env";

export async function getIndex(): Promise<IndexValues> {
    const result = await fetch(`${process.env.BUN_PUBLIC_TILE_SERVER}/api/index?${getEnvParam()}`, {
        headers: {
            "X-API-KEY": process.env.BUN_PUBLIC_TILE_SERVER_API_KEY
        }
    });

    // TODO: Error handling;

    return result.json();
}
